<template>
	<div>
		<case-form :schema="schemaPolitical" class="mt6" />
		<div class="fs4 fw7 lh125 mt6">
			如果“是”，请说明头衔/官阶，职责详情，任职时间，以及与该PEP的关系
		</div>
		<div class="fs4 fw7 lh125 mt6">
			如选择"是"，请完成以下问题：
		</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">详情</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaPEP(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<case-form :schema="schema" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">
			受到政治曝光的人所担任的职位是什么？
		</div>
		<case-form :schema="schemaPosition" />

		<div class="xs-12 fs4 fw7 mb2 mt6">
			与此人的关系？
		</div>
		<case-form :schema="schemaRelationship" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schema() {
			return [
				{
					label: `您或您的近亲是否是政治人物或您或您的近亲（无论在世或身故），曾经是政治人物，任何联合军队的成员，工会官
员或记者？（近亲是指配偶，民事同居伴侣或同居伴侣，子女，继子女，兄弟姐妹，同父异母或同母异父兄弟姐妹、
继兄弟姐 妹，客户的生父母或养父母，客户配偶，民事同居伴侣或同居伴侣的生父母或养父母）`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isOrIsRelativeOfPEPCN`,
					props: {
						suggest: {
							typeIncludes: `isOrIsRelativeOfPEPCN`
						},
						createOptions: {
							type: `isOrIsRelativeOfPEPCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `曾今担任或在担任职位的人的名字是什么？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPNameCN`,
					props: {
						suggest: {
							typeIncludes: `PEPNameCN`
						},
						createOptions: {
							type: `PEPNameCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `在哪个国家/地区担任该职位`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPCountryHeldCN`,
					props: {
						suggest: {
							typeIncludes: `PEPCountryHeldCN`
						},
						createOptions: {
							type: `PEPCountryHeldCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `开始日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPPositionHeldFromCN`,
					props: {
						suggest: {
							typeIncludes: `PEPPositionHeldFromCN`
						},
						createOptions: {
							type: `PEPPositionHeldFromCN`,
							dataType: "date"
						}
					}
				},
				{
					label: `结束日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPPositionHeldToCN`,
					props: {
						suggest: {
							typeIncludes: `PEPPositionHeldToCN`
						},
						createOptions: {
							type: `PEPPositionHeldToCN`,
							dataType: "date"
						}
					}
				},
				{
					label: `头衔/官阶`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPTitleOfPositionCN`,
					props: {
						suggest: {
							typeIncludes: `PEPTitleOfPositionCN`
						},
						createOptions: {
							type: `PEPTitleOfPositionCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaPolitical() {
			return [
				{
					label: `您或您的近亲是否是政治人物或您或您的近亲（无论在世或身故），曾经是政治人物，任何联合军队的成员，工会官
员或记者？（近亲是指配偶，民事同居伴侣或同居伴侣，子女，继子女，兄弟姐妹，同父异母或同母异父兄弟姐妹、
继兄弟姐 妹，客户的生父母或养父母，客户配偶，民事同居伴侣或同居伴侣的生父母或养父母）`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isOrIsRelativeOfPEPCN`,
					props: {
						suggest: {
							typeIncludes: `insured0isOrIsRelativeOfPEPCN`
						},
						createOptions: {
							type: `insured0isOrIsRelativeOfPEPCN`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaPosition() {
			return [
				{
					label: `国家元首或政府首脑`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisHeadOfStateOrGovtCN`,
					props: {
						suggest: {
							typeIncludes: `PEPisHeadOfStateOrGovtCN`
						},
						createOptions: {
							type: `PEPisHeadOfStateOrGovtCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `政府机构负责人`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisHeadOfGovtAgencyCN`,
					props: {
						suggest: {
							typeIncludes: `PEPisHeadOfGovtAgencyCN`
						},
						createOptions: {
							type: `PEPisHeadOfGovtAgencyCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `行政会议或立法机关成员`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisMemberOfCouncilOrLegislatureCN`,
					props: {
						suggest: {
							typeIncludes: `PEPisMemberOfCouncilOrLegislatureCN`
						},
						createOptions: {
							type: `PEPisMemberOfCouncilOrLegislatureCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `法官`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisJudgeCN`,
					props: {
						suggest: {
							typeIncludes: `PEPisJudgeCN`
						},
						createOptions: {
							type: `PEPisJudgeCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `副部长`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisDeputyMinisterCN`,
					props: {
						suggest: {
							typeIncludes: `PEPisDeputyMinisterCN`
						},
						createOptions: {
							type: `PEPisDeputyMinisterCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `政党领导人或总统`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisLeaderOrPresidentOfPoliticalPartyCN`,
					props: {
						suggest: {
							typeIncludes: `PEPisLeaderOrPresidentOfPoliticalPartyCN`
						},
						createOptions: {
							type: `PEPisLeaderOrPresidentOfPoliticalPartyCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `大使`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisAmbassadorCN`,
					props: {
						suggest: {
							typeIncludes: `PEPisAmbassadorCN`
						},
						createOptions: {
							type: `PEPisAmbassadorCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `军事将军`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisMilitaryGeneralCN`,
					props: {
						suggest: {
							typeIncludes: `PEPisMilitaryGeneralCN`
						},
						createOptions: {
							type: `PEPisMilitaryGeneralCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `国有公司或银行的总裁`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisPresidentOfCompanyOrBankCN`,
					props: {
						suggest: {
							typeIncludes: `PEPisPresidentOfCompanyOrBankCN`
						},
						createOptions: {
							type: `PEPisPresidentOfCompanyOrBankCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `其他`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisOthersCN`,
					props: {
						suggest: {
							typeIncludes: `PEPisOthersCN`
						},
						createOptions: {
							type: `PEPisOthersCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `(请明细)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisOthersDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `PEPisOthersDetailsCN`
						},
						createOptions: {
							type: `PEPisOthersDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaRelationship() {
			return [
				{
					label: `自我`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisInsuredCN`,
					props: {
						suggest: {
							typeIncludes: `PEPisInsuredCN`
						},
						createOptions: {
							type: `PEPisInsuredCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `母亲或父亲`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisParentCN`,
					props: {
						suggest: {
							typeIncludes: `PEPisParentCN`
						},
						createOptions: {
							type: `PEPisParentCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `伴侣`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisPartnerCN`,
					props: {
						suggest: {
							typeIncludes: `PEPisPartnerCN`
						},
						createOptions: {
							type: `PEPisPartnerCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `兄弟姐妹`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisSiblingCN`,
					props: {
						suggest: {
							typeIncludes: `PEPisSiblingCN`
						},
						createOptions: {
							type: `PEPisSiblingCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `孩子`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisChildCN`,
					props: {
						suggest: {
							typeIncludes: `PEPisChildCN`
						},
						createOptions: {
							type: `PEPisChildCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `配偶父母`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisPartnersParentCN`,
					props: {
						suggest: {
							typeIncludes: `PEPisPartnersParentCN`
						},
						createOptions: {
							type: `PEPisPartnersParentCN`,
							dataType: "boolean"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaPEP(i) {
			return [
				{
					label: `头衔/官阶`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0politicalPersonTitleOrRank${i}CN`,
					props: {
						suggest: {
							typeIncludes: `politicalPersonTitleOrRank${i}CN`
						},
						createOptions: {
							type: `politicalPersonTitleOrRank${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `职责详情`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0politicalPersonDuties${i}CN`,
					props: {
						suggest: {
							typeIncludes: `politicalPersonDuties${i}CN`
						},
						createOptions: {
							type: `politicalPersonDuties${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `开始日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0politicalPersonHeldPositionFrom${i}CN`,
					props: {
						suggest: {
							typeIncludes: `politicalPersonHeldPositionFrom${i}CN`
						},
						createOptions: {
							type: `politicalPersonHeldPositionFrom${i}CN`,
							dataType: "date"
						}
					}
				},
				{
					label: `结束日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0politicalPersonHeldPositionTo${i}CN`,
					props: {
						suggest: {
							typeIncludes: `politicalPersonHeldPositionTo${i}CN`
						},
						createOptions: {
							type: `politicalPersonHeldPositionTo${i}CN`,
							dataType: "date"
						}
					}
				},
				{
					label: `与该PEP的关系`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0relationshipToPEP${i}CN`,
					props: {
						suggest: {
							typeIncludes: `relationshipToPEP${i}CN`
						},
						createOptions: {
							type: `relationshipToPEP${i}CN`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
